module.exports = __webpack_public_path__ + "static/media/lainformacion.a56b81ad.png";